import { useEffect, useState } from "react";

const WIDE = "(min-width: 1024px)";

/** `lg` (1024 px) va undan keng ekran: chap panel doimiy, katta ko'rinish yonma-yon. */
export function useWide() {
  const [wide, setWide] = useState(() => window.matchMedia(WIDE).matches);
  useEffect(() => {
    const m = window.matchMedia(WIDE);
    const on = () => setWide(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, []);
  return wide;
}
